const evaluateStepSize = (stepsCount: number) => {
  // First step is always at 0% so I remove it from percent count(and the last one at 100%)
  return 100 / stepsCount;
};

export const useStepper = (steps: number, activeStep: number) => {
  const size = evaluateStepSize(steps);

  return {
    stepSize: size,
    progressSize: (100 / (steps - 1)) * activeStep,
  };
};
